import React, { useState } from "react";
import { Link } from "react-router-dom";
import AssignCoach from "./AssignCoach";
import AssignOps from "./AssignOps";
import AssignBiz from "./AssignBiz";

const AssignToHPC = () => {

    const [activeTab, setActiveTab] = useState("Coach");

    const tabData = [
        {
            icon: <i className="fas fa-users" />,
            name: "Coach",
            content: <AssignCoach />
        },
        {
            icon: <i className="fas fa-running" />,
            name: "Ops Manager",
            content: <AssignOps />
        },
        {
            icon: <i className="fas fa-running" />,
            name: "Biz User",
            content: <AssignBiz />
        },
    ]
    return (
        <>
            <div className="content container" style={{ maxWidth: "1500px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row d-flex align-items-center">
                                <div className="col-xl-12 col-lg-12 col-sm-12 col-md-12">
                                    <div className="coach-court-list">
                                        <ul className="nav">
                                            {tabData.map((tab, i) => (
                                                <li key={i}>
                                                    <Link
                                                        to="#"
                                                        className={tab.name === activeTab ? "active" : ""}
                                                        onClick={() => setActiveTab(tab.name)}
                                                    >
                                                        {tab.icon} {tab.name}
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                                <div className="tab-content">
                                    {tabData
                                        .filter(tab => tab.name === activeTab)
                                        .map((tab, i) => (
                                            <div key={i}>{tab.content}</div>
                                        ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AssignToHPC;